import Vue from "vue";
import { Component } from "vue-property-decorator";
import VForm from "../../../../models/v-form";

@Component
export default class SettlementCostDocumentAttachmentDialog extends Vue {
    requiredRule = (value: string) => !!value || this.$t("common.validationErrorRequired");

    get attachmentDialogAttachments(): any[] {
        return this.$store.direct.state.settlementCostDocument.attachmentDialogAttachments;
    }

    set attachmentDialogAttachments(value: any[]) {
        this.$store.direct.commit.settlementCostDocument.setAttachmentDialogAttachments(value);
    }

    get isLoading(): boolean {
        return this.$store.direct.state.loading;
    }

    get showDialog(): boolean {
        return this.$store.direct.state.settlementCostDocument.showAttachmentDialog;
    }

    updated() {
        this.$nextTick(function () {
            if (this.$refs.form) (this.$refs.form as VForm).resetValidation();
        });
    }

    async saveClick(): Promise<void> {
        if ((this.$refs.form as VForm).validate()) {
            await this.$store.direct.dispatch.settlementCostDocument.isConfirmedAttachmentDialog();
            this.$store.direct.commit.settlementCostDocument.setAttachmentDialogAttachments(this.attachmentDialogAttachments);
        }
    }
    closeClick(): void {
        this.$store.direct.dispatch.settlementCostDocument.isNotConfirmedAttachmentDialog();
    }
}
